export const boundariesVeryCautious = [
  [5000, 5000],
  [4992, 5028],
  [4995, 5046],
  [4999, 5062],
  [5005, 5078],
  [5011, 5092],
  [5017, 5107],
  [5024, 5121],
  [5031, 5135],
  [5038, 5148],
  [5045, 5162],
  [5053, 5175],
  [5060, 5189],
  [5068, 5202],
  [5076, 5215],
  [5084, 5228],
  [5092, 5241],
  [5100, 5254],
  [5108, 5267],
  [5117, 5280],
  [5125, 5293],
  [5134, 5306],
  [5142, 5319],
  [5151, 5332],
  [5159, 5345],
  [5168, 5358],
  [5177, 5371],
  [5185, 5384],
  [5194, 5397],
  [5203, 5410],
  [5212, 5422],
  [5221, 5435],
  [5230, 5448],
  [5239, 5461],
  [5248, 5474],
  [5257, 5487],
  [5266, 5500],
  [5276, 5513],
  [5285, 5526],
  [5294, 5538],
  [5303, 5551],
  [5313, 5564],
  [5322, 5577],
  [5331, 5590],
  [5341, 5603],
  [5350, 5616],
  [5360, 5629],
  [5369, 5642],
  [5379, 5655],
  [5389, 5668],
  [5398, 5681],
  [5408, 5694],
  [5418, 5707],
  [5427, 5721],
  [5437, 5734],
  [5447, 5747],
  [5457, 5760],
  [5467, 5773],
  [5476, 5786],
  [5486, 5800],
  [5496, 5813],
  [5506, 5826],
  [5516, 5839],
  [5526, 5853],
  [5536, 5866],
  [5546, 5879],
  [5557, 5893],
  [5567, 5906],
  [5577, 5919],
  [5587, 5933],
  [5597, 5946],
  [5608, 5960],
  [5618, 5973],
  [5628, 5987],
  [5638, 6000],
  [5649, 6014],
  [5659, 6027],
  [5670, 6041],
  [5680, 6054],
  [5690, 6068],
  [5701, 6082],
  [5711, 6095],
  [5722, 6109],
  [5733, 6123],
  [5743, 6136],
  [5754, 6150],
  [5764, 6164],
  [5775, 6178],
  [5786, 6192],
  [5797, 6205],
  [5807, 6219],
  [5818, 6233],
  [5829, 6247],
  [5840, 6261],
  [5851, 6275],
  [5861, 6289],
  [5872, 6303],
  [5883, 6317],
  [5894, 6331],
  [5905, 6345],
  [5916, 6360],
  [5927, 6374],
  [5938, 6388],
  [5949, 6402],
  [5960, 6416],
  [5972, 6431],
  [5983, 6445],
  [5994, 6459],
  [6005, 6474],
  [6016, 6488],
  [6028, 6502],
  [6039, 6517],
  [6050, 6531],
  [6062, 6546],
  [6073, 6560],
  [6084, 6575],
  [6096, 6589],
  [6107, 6604],
  [6119, 6618],
  [6130, 6633],
  [6142, 6648],
];

export const developmentVeryCautious = [
  5000, 5010, 5021, 5031, 5041, 5051, 5062, 5072, 5083, 5093, 5103, 5114, 5124, 5135,
  5145, 5156, 5166, 5177, 5188, 5198, 5209, 5220, 5230, 5241, 5252, 5262, 5273, 5284,
  5295, 5306, 5317, 5327, 5338, 5349, 5360, 5371, 5382, 5393, 5404, 5415, 5426, 5438,
  5449, 5460, 5471, 5482, 5493, 5505, 5516, 5527, 5539, 5550, 5561, 5573, 5584, 5596,
  5607, 5619, 5630, 5642, 5653, 5665, 5676, 5688, 5700, 5711, 5723, 5735, 5746, 5758,
  5770, 5782, 5794, 5806, 5817, 5829, 5841, 5853, 5865, 5877, 5889, 5901, 5913, 5926,
  5938, 5950, 5962, 5974, 5987, 5999, 6011, 6023, 6036, 6048, 6060, 6073, 6085, 6098,
  6110, 6123, 6135, 6148, 6160, 6173, 6186, 6198, 6211, 6224, 6237, 6249, 6262, 6275,
  6288, 6301, 6314, 6327, 6340, 6353, 6366, 6379, 6392,
];

export const fluctuationVeryCautious = [
  5000, 5013, 5020, 5021, 4999, 5002, 5029, 5045, 5066, 5086, 5094, 5112, 5124, 5131,
  5131, 5139, 5149, 5167, 5175, 5183, 5185, 5196, 5213, 5231, 5252, 5259, 5270, 5299,
  5308, 5300, 5288, 5291, 5303, 5324, 5346, 5365, 5382, 5396, 5417, 5422, 5419, 5427,
  5460, 5474, 5470, 5463, 5476, 5488, 5516, 5508, 5508, 5526, 5526, 5521, 5539, 5552,
  5574, 5617, 5644, 5657, 5653, 5670, 5688, 5704, 5718, 5744, 5753, 5741, 5708, 5706,
  5724, 5763, 5794, 5803, 5815, 5828, 5827, 5814, 5835, 5860, 5886, 5902, 5906, 5922,
  5938, 5946, 5952, 5953, 5960, 5990, 6003, 6032, 6049, 6063, 6070, 6073, 6085, 6095,
  6100, 6102, 6103, 6096, 6093, 6104, 6126, 6150, 6189, 6219, 6237, 6274, 6285, 6304,
  6307, 6315, 6302, 6300, 6312, 6310, 6335, 6367, 6392,
];
